import {Voucher} from '@gongxigames/framework/integrations/pariplay/Voucher';
import {consoleLogger} from '@gongxigames/framework/core';

export class PPResponse {
    public static readonly NULL_RESPONSE_ERROR: number = 3;

    public source: any;

    constructor(source: any) {
        this.source = source;
    }

    public getBalance(): number {
        return 0;
    }

    public getErrorCode(): number {
        if (!this.source || !this.source.Status) {
            return PPResponse.NULL_RESPONSE_ERROR;
        }

        return this.source.Status.ErrCode;
    }

    public getVoucher(): Voucher | undefined {
        const voucher = this.source.Voucher as Voucher;

        if (voucher) {
            this.setDefaultStakeToVoucher(voucher);
        }

        return voucher;
    }

    public getErrorType(): number {
        return this.source.Status.ErrType;
    }

    private setDefaultStakeToVoucher(voucher: Voucher): void {
        const stake: number = voucher.DefaultStake;

        if (!stake) {
            if (this.source.Stakes && this.source.Stakes[0]) {
                voucher.DefaultStake = this.source.Stakes[0];
            } else if (this.source.Input && this.source.Input.Stake) {
                voucher.DefaultStake = this.source.Input.Stake;
            } else {
                consoleLogger.warn('stake is undefined using stake = 1');
                voucher.DefaultStake = 1;
            }
        }
    }
}
